import React, { useState, useEffect, useRef, Fragment } from "react";
import axios from "axios";
import moment from "moment";
import Select from "../select/Select";
import Calendar from "react-calendar";
import MultiSelect from "../multiselect/MultiSelect";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import "./Availability.css";
import AvailabilitySelect from "../select/AvailabilitySelect";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#1e1e1e",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#1e1e1e",
    fontSize: theme.typography.pxToRem(14),
    padding: "10px 15px",
    marginLeft: "20px",
    pointerEvents: "none",
  },
}));

const Availability = () => {
  useEffect(() => {
    setIsLoaded(false);
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "cloud_therapist/get-availability-data", {})
      .then((res) => {
        if (res.data.responseData) {
          var response_times = res.data.responseData.available_times;
          setAvailData(response_times);

          var response_tz = res.data.responseData.user_time_zone;
          var breakTime = moment()
            .utc()
            .add(parseInt(response_tz.utc_offset), "hours")
            .format("LT");
          setInitialTimeZone(response_tz.time_zone_name + ",    " + breakTime);

          var response_periods = res.data.responseData.available_periods;
          for (var period of response_periods) {
            period.times_date = [
              moment(period.times_date[0]).format("l"),
              moment(period.times_date[1]).format("l"),
            ];
          }

          setAvailPopTimeSlotsSel(response_periods);
          setIsLoaded(true);
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.errorData) {
          setAvailHidden(error.response.data.errorData);
          setIsLoaded(true);
        }
      });
  }, []);

  const [availData, setAvailData] = useState([
    {
      day_name: "Monday",
      available: false,
      times: [{ start_time: "", end_time: "" }],
    },
    {
      day_name: "Tuesday",
      available: false,
      times: [{ start_time: "", end_time: "" }],
    },
    {
      day_name: "Wednesday",
      available: false,
      times: [{ start_time: "", end_time: "" }],
    },
    {
      day_name: "Thursday",
      available: false,
      times: [{ start_time: "", end_time: "" }],
    },
    {
      day_name: "Friday",
      available: false,
      times: [{ start_time: "", end_time: "" }],
    },
    {
      day_name: "Saturday",
      available: false,
      times: [{ start_time: "", end_time: "" }],
    },
    {
      day_name: "Sunday",
      available: false,
      times: [{ start_time: "", end_time: "" }],
    },
  ]);

  const [initialTimeZone, setInitialTimeZone] = useState(
    "Eastern Time - US & Canada"
  );
  const [timeZoneOptions] = useState([
    {
      time_zone_name: "Pacific Time - US & Canada",
      utc_offset: moment().isDST() ? "-7" : "-8",
    },
    {
      time_zone_name: "Mountain Time - US & Canada",
      utc_offset: moment().isDST() ? "-6" : "-7",
    },
    {
      time_zone_name: "Central Time - US & Canada",
      utc_offset: moment().isDST() ? "-5" : "-6",
    },
    {
      time_zone_name: "Eastern Time - US & Canada",
      utc_offset: moment().isDST() ? "-4" : "-5",
    },
    {
      time_zone_name: "Alaska Time",
      utc_offset: moment().isDST() ? "-8" : "-9",
    },
    {
      time_zone_name: "Arizona Yukon Time",
      utc_offset: moment().isDST() ? "-6" : "-7",
    },
  ]);

  const [isLoaded, setIsLoaded] = useState(false);
  const [availHidden, setAvailHidden] = useState("");
  const [timeZoneSelectOpts, setTimeZoneSelectOpts] = useState([]);
  const [availHours, setAvailHours] = useState([]);
  const [availPopHours, setAvailPopHours] = useState([]);
  const [availToolHeight, setAvailToolHeight] = useState(0);
  const [availToolLeft, setAvailToolLeft] = useState(0);
  const [hoveredDay, setHoveredDay] = useState("");
  const [copyOrNew, setCopyOrNew] = useState("");
  const [openMulti, setOpenMulti] = useState(-1);
  const [daysToCopy, setDaysToCopy] = useState([]);
  const [openDateOverride, setOpenDateOverride] = useState(false);
  const [availPopDate, setAvailPopDate] = useState(null);
  const [availPopTimeSlots, setAvailPopTimeSlots] = useState([
    { start_time: "", end_time: "" },
  ]);
  const [notAvailPopTimeSlots, setNotAvailPopTimeSlots] = useState([
    { start_time: "", end_time: "" },
  ]);
  const [availPopTimeSlotsSel, setAvailPopTimeSlotsSel] = useState([]);
  const [availTimesError, setAvailTimesError] = useState(false);
  const [availPopTimesError, setAvailPopTimesError] = useState(false);
  const [errorPopUp, setErrorPopUp] = useState("");
  const [succPopUp, setSuccPopUp] = useState("");

  const [delDateOverride, setDelDateOverride] = useState(false);

  const [overideTimeFormat, setOverideTimeFormat] = useState("Available");
  const [errorRange, setErrorRange] = useState(false);
  const [rememberInx, setRememberInx] = useState();
  const [rememberInxDel, setRememberInxDel] = useState();
  const [isNewDate, setNewDate] = useState();

  const [copyDayArr, setCopyDayArr] = useState([
    { value: "Monday", key: 0 },
    { value: "Tuesday", key: 1 },
    { value: "Wednesday", key: 2 },
    { value: "Thursday", key: 3 },
    { value: "Friday", key: 4 },
    { value: "Saturday", key: 5 },
    { value: "Sunday", key: 6 },
  ]);

  const popupRef = useRef(errorPopUp);
  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);

  const succPopupRef = useRef(succPopUp);
  useEffect(() => {
    succPopupRef.current = succPopUp;
    const timeout = setTimeout(() => {
      setSuccPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [succPopUp]);

  const createHours = (pop) => {
    var timeArr = [];
    var initTime = moment().format().split("T")[0];
    var breakTime = moment(initTime).format("LT");
    timeArr.push({ value: breakTime });

    for (var i = 1; i < 100; i++) {
      var time = moment(initTime)
        .add(30 * i, "minutes")
        .format("LT");
      if (time.slice(0, 2) !== 10 && time.slice(0, 2) !== 11 && time.slice(0, 2) !== 12) {
        time =
          moment(initTime)
            .add(30 * i, "minutes")
            .format("LT");
      } else {
        time = moment(initTime)
          .add(30 * i, "minutes")
          .format("LT");
      }

      if (time !== breakTime) {
        if (pop) {
          if (new Date(moment(initTime).add(30 * i, "minutes")) > new Date()) {
            timeArr.push({ value: time });
          }
        } else {
          timeArr.push({ value: time });
        }
      } else {
        break;
      }
    }

    if (pop) {
      if (moment(initTime) < new Date()) {
        timeArr.splice(0, 1);
      }
      setAvailPopHours(timeArr);
    } else {
      setAvailHours(timeArr);
    }
  };

  useEffect(() => {
    const timeout = setInterval(() => {
      createHours(true);
    }, 1000);
    return () => {
      clearInterval(timeout);
    };
  }, [succPopUp]);

  const createTimeZoneOpts = () => {
    var timeZoneSelect = [];
    for (var timezone of timeZoneOptions) {
      var breakTime = moment()
        .utc()
        .add(parseInt(timezone.utc_offset), "hours")
        .format("LT");
      var selectedOffset;
      if (timezone.time_zone_name === initialTimeZone.split(",")[0]) {
        selectedOffset = timezone.utc_offset;
      }

      timeZoneSelect.push({
        value: timezone.time_zone_name + ",    " + breakTime,
      });
    }
    var selectedNewTime = moment()
      .utc()
      .add(parseInt(selectedOffset), "hours")
      .format("LT");
    setInitialTimeZone(
      initialTimeZone.split(",")[0] + ",    " + selectedNewTime
    );
    setTimeZoneSelectOpts(timeZoneSelect);
  };

  useEffect(() => {
    createHours();
    createTimeZoneOpts();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    var timeUpdate = setInterval(() => {
      createTimeZoneOpts();
    }, 1000);

    return () => clearInterval(timeUpdate);
  });

  const handleAvailable = (item) => {
    var changedAvail = [...availData];
    changedAvail[item].available = !changedAvail[item].available;
    changedAvail[item].times = [
      {
        start_time: changedAvail[item].times.start_time,
        end_time: changedAvail[item].times.end_time,
      },
    ]
      ? [
          {
            start_time: changedAvail[item].times.start_time,
            end_time: changedAvail[item].times.end_time,
          },
        ]
      : [{ start_time: "", end_time: "" }];
    setAvailTimesError(false);

    setAvailData(changedAvail);
  };

  const handleAvailTool = (item, event, copy_or_new) => {
    if (item === "close") {
      setAvailToolHeight(0);
      setAvailToolLeft(0);
      setCopyOrNew("");
    } else {
      setHoveredDay(item.day_name.toLowerCase());
      setCopyOrNew(copy_or_new);

      setAvailToolHeight(event.clientY - 65 - event.nativeEvent.layerY);
      setAvailToolLeft(event.target.offsetLeft + 202);
    }
  };

  const handleUserTimeZone = (mod, timezone) => {
    mod(timezone);
  };

  const addNewTime = (item) => {
    var changedAvail = [...availData];
    changedAvail[item].times.push({ start_time: "", end_time: "" });
    setAvailData(changedAvail);
  };

  const deleteTime = (item, mod) => {
    var changedAvail = [...availData];
    changedAvail[item].times.splice(mod, 1);
    setAvailData(changedAvail);
  };

  const openCloseMulti = (item, apply, day) => {
    if (item === openMulti) {
      setOpenMulti(-1);
    } else {
      setOpenMulti(item);
    }

    if (item >= 0) {
      var changedAvailDay = [...copyDayArr];
      for (var day1 of copyDayArr) {
        if (day1.value === day) {
          changedAvailDay.splice(copyDayArr.indexOf(day1), 1);
          setCopyDayArr(changedAvailDay);
        }
      }
    } else {
      setCopyDayArr([
        { value: "Monday", key: 0 },
        { value: "Tuesday", key: 1 },
        { value: "Wednesday", key: 2 },
        { value: "Thursday", key: 3 },
        { value: "Friday", key: 4 },
        { value: "Saturday", key: 5 },
        { value: "Sunday", key: 6 },
      ]);
    }

    if (apply) {
      var changedAvail = [...availData];
      var modelDay = { ...changedAvail[openMulti] };
// eslint-disable-next-line
      for (var day of daysToCopy) {
        var newTimes = [];
        for (var modelTime of [...modelDay.times]) {
          newTimes.push({
            start_time: modelTime.start_time,
            end_time: modelTime.end_time,
          });
        }

        changedAvail[day.key].times = newTimes;
        changedAvail[day.key].available = true;
      }
      setAvailData(changedAvail);
    }
    setDaysToCopy([]);
  };

  const handleHours = (matrix, val) => {
    let changedAvail = [...availData];
    let placeholderDate = moment().format().split("T")[0];

    // Format the selected time as a comparable date object
    let selectedTime = new Date(moment(`${placeholderDate} ${val}`).format());
    let skipDateCheck =
        !changedAvail[matrix[0]].times[matrix[1]].start_time &&
        !changedAvail[matrix[0]].times[matrix[1]].end_time;

    // Ensure start_time is before end_time for the same interval
    if (!skipDateCheck) {
        let oppositeTime = new Date(
            moment(
                `${placeholderDate} ${changedAvail[matrix[0]].times[matrix[1]][matrix[2] === "start_time" ? "end_time" : "start_time"]}`
            ).format()
        );

        if (
            (matrix[2] === "start_time" && selectedTime >= oppositeTime) ||
            (matrix[2] === "end_time" && selectedTime <= oppositeTime)
        ) {
            setAvailTimesError(true);
            changedAvail[matrix[0]].times[matrix[1]][matrix[2]] = "";
            setAvailData(changedAvail);
            setErrorPopUp("Please insert a correct time interval.");
            return;
        }
    }

    // Ensure all other time intervals for the same day are compared
    for (let i = 0; i < changedAvail[matrix[0]].times.length; i++) {
      if (i === matrix[1]) continue; // Skip the current interval

      let existingTime = changedAvail[matrix[0]].times[i];
      if (!existingTime.start_time || !existingTime.end_time) continue; // Skip incomplete intervals

      let existingStart = new Date(moment(`${placeholderDate} ${existingTime.start_time}`).format());
      let existingEnd = new Date(moment(`${placeholderDate} ${existingTime.end_time}`).format());

      // Check if the new time overlaps with any existing interval
      if (
          (matrix[2] === "start_time" && selectedTime >= existingStart && selectedTime < existingEnd) ||
          (matrix[2] === "end_time" && selectedTime > existingStart && selectedTime <= existingEnd)
      ) {
          setAvailTimesError(true);
          changedAvail[matrix[0]].times[matrix[1]][matrix[2]] = "";
          setAvailData(changedAvail);
          setErrorPopUp("Time frame is already used.");
          return;
      }
    }

    // Update the time if no issues are found
    changedAvail[matrix[0]].times[matrix[1]][matrix[2]] = val;
    setAvailTimesError(false);
    setAvailData(changedAvail);
};


  const handleDaysToCopyTo = (mod, currDay) => {
    var currentDay = availData[currDay].day_name;
    var newMod = [];
    for (var day of mod) {
      if (day.value !== currentDay) {
        newMod.push(day);
      }
    }
    setDaysToCopy(newMod);
  };

  const openCloseDateOverride = (apply) => {
    if (apply) {

      // --------------- CHECK FOR CONFLICTED TIMES ----------------------

      const isTimeConflict = (start1, end1, start2, end2) => {
        const s1 = moment(start1, "h:mma");
        const e1 = moment(end1, "h:mma");
        const s2 = moment(start2, "h:mma");
        const e2 = moment(end2, "h:mma");
        return s1.isBefore(e2) && s2.isBefore(e1);
      };

      const hasValidTimeSlots = (slots) => 
        Array.isArray(slots) && slots.some(slot => slot.start_time || slot.end_time);
      
      const checkSlotsForConflict = (slots, dateStart, dateEnd, allowHours, blockHours) => {
        return slots.some(newSlot =>
          availPopDate[0] === dateStart &&
          availPopDate[1] === dateEnd &&
          (
            (allowHours && isTimeConflict(newSlot.start_time, newSlot.end_time, allowHours.start_time, allowHours.end_time)) ||
            (blockHours && isTimeConflict(newSlot.start_time, newSlot.end_time, blockHours.start_time, blockHours.end_time))
          )
        );
      };
      
      const checkForConflicts = () => {
        for (let sel of availPopTimeSlotsSel) {
          const [dateStart, dateEnd] = sel.times_date;
          for (let timeData of sel.times_data) {
            const { allow_hours: allowHours, block_hours: blockHours } = timeData;
      
            if (hasValidTimeSlots(availPopTimeSlots)) {
              if (checkSlotsForConflict(availPopTimeSlots, dateStart, dateEnd, allowHours, blockHours)) {
                return true;
              }
            } else if (hasValidTimeSlots(notAvailPopTimeSlots)) {
              if (checkSlotsForConflict(notAvailPopTimeSlots, dateStart, dateEnd, allowHours, blockHours)) {
                return true;
              }
            }
          }
        }
        return false;
      };
      
      if (checkForConflicts()) {
        setAvailPopTimesError(true);
        setErrorPopUp("Time frame is already used. Please adjust and try again.");
        return;
      }

      // --------------- CHECK FOR CONFLICTED TIMES ----------------------

      var timeSlotCheck = function () {
        var isAllFilled = true;
        for (var slot of availPopTimeSlots) {
          // if (!slot.start_time || !slot.end_time) {
          //   isAllFilled = false;
          // }

          if (slot.start_time && slot.end_time) {
            var beginningTime = moment(slot.start_time, "h:mma");
            var endTime = moment(slot.end_time, "h:mma");

            let errRange = beginningTime.isBefore(endTime);
            if (!errRange) {
              isAllFilled = false;
              setErrorRange(true);
            }
          }

          if (
            (!slot.start_time && slot.end_time) ||
            (slot.start_time && !slot.end_time)
          ) {
            isAllFilled = false;
          }
        }
        return isAllFilled;
      };

      var notAvailable = function () {
        var isAllFilled = true;
        for (var slot of notAvailPopTimeSlots) {
          if (slot.start_time && slot.end_time) {
            var beginningTime = moment(slot.start_time, "h:mma");
            var endTime = moment(slot.end_time, "h:mma");

            let errRange = beginningTime.isBefore(endTime);
            if (!errRange) {
              isAllFilled = false;
              setErrorRange(true);
            }
          }

          if (
            (!slot.start_time && slot.end_time) ||
            (slot.start_time && !slot.end_time)
          ) {
            isAllFilled = false;
          }
        }
        return isAllFilled;
      };

      if (
        overideTimeFormat === "Available" &&
        (availPopTimeSlots[0]?.start_time === "" ||
          availPopTimeSlots[0]?.end_time === "")
      ) {
        setAvailPopTimesError(true);
        setErrorPopUp("Please complete all required fields highlighted in red, then try saving again.");
        return;
      } else if (
        overideTimeFormat === "NotAvailable" &&
        (notAvailPopTimeSlots[0]?.start_time === "" ||
          notAvailPopTimeSlots[0]?.end_time === "")
      ) {
        setAvailPopTimesError(true);
        setErrorPopUp("Please complete all required fields highlighted in red, then try saving again.");
        return;
      }

      if (!availPopDate || !timeSlotCheck() || !notAvailable()) {
        setAvailPopTimesError(true);
        setErrorPopUp("Please complete all required fields highlighted in red, then try saving again.");
        return;
      }

      var availSave = [...availPopTimeSlotsSel];
      const timesData = [];
      let allowHours = availPopTimeSlots[0];
      if (allowHours.start_time && allowHours.end_time) {
        timesData.push({ allow_hours: allowHours });
      }
      let blockHours = notAvailPopTimeSlots[0];
      if (blockHours.start_time && blockHours.end_time) {
        timesData.push({ block_hours: blockHours });
      }
      //availSave.push({ times_date: availPopDate, times_data: [...availPopTimeSlots] });
      availSave.push({
        times_date: availPopDate,
        times_data: timesData,
      });
      setAvailPopTimeSlotsSel(availSave);
    }

    setOpenDateOverride(!openDateOverride);
    setAvailPopDate(null);
    setAvailPopTimeSlots([{ start_time: "", end_time: "" }]);
    setNotAvailPopTimeSlots([{ start_time: "", end_time: "" }]);
    setAvailPopTimesError(false);

    setDelDateOverride(false);

    setErrorRange(false);
  };

  const updateDate = (newDate) => {
    setNewDate(newDate);
    setAvailPopDate([
      moment(newDate[0]).format("l"),
      moment(newDate[1]).format("l"),
    ]);
    if (isNewDate) {
      setAvailPopTimeSlots([
        {
          start_time: availPopTimeSlots[0].start_time,
          end_time: availPopTimeSlots[0].end_time,
        },
      ]);
      setNotAvailPopTimeSlots([
        {
          start_time: notAvailPopTimeSlots[0].start_time,
          end_time: notAvailPopTimeSlots[0].end_time,
        },
      ]);
    }
  };

  const onClickDay = (value) => {
    setAvailPopDate([moment(value).format("l"), moment(value).format("l")]);
    if (
      availPopTimeSlots[0].start_time &&
      availPopTimeSlots[0].end_time &&
      isNewDate
    ) {
      setAvailPopTimeSlots([{ start_time: "", end_time: "" }]);
    } else {
      setAvailPopTimeSlots([
        {
          start_time: availPopTimeSlots[0].start_time,
          end_time: availPopTimeSlots[0].end_time,
        },
      ]);
    }
    if (
      notAvailPopTimeSlots[0].start_time &&
      notAvailPopTimeSlots[0].end_time &&
      isNewDate
    ) {
      setNotAvailPopTimeSlots([{ start_time: "", end_time: "" }]);
    } else {
      setNotAvailPopTimeSlots([
        {
          start_time: notAvailPopTimeSlots[0].start_time,
          end_time: notAvailPopTimeSlots[0].end_time,
        },
      ]);
    }
  };

  const onActiveStartDateChange = (value) => {
    if (
      (value.action === "next" && !availPopTimeSlots[0].start_time) ||
      !notAvailPopTimeSlots[0].start_time
    ) {
      setAvailPopTimeSlots([
        {
          start_time: availPopTimeSlots[0].start_time,
          end_time: availPopTimeSlots[0].end_time,
        },
      ]);
      setNotAvailPopTimeSlots([
        {
          start_time: notAvailPopTimeSlots[0].start_time,
          end_time: notAvailPopTimeSlots[0].end_time,
        },
      ]);
    } else if (
      (value.action === "prev" && availPopTimeSlots[0].start_time) ||
      notAvailPopTimeSlots[0].start_time ||
      availPopTimeSlots[0].end_time ||
      notAvailPopTimeSlots[0].end_time ||
      (availPopTimeSlots[0].start_time && availPopTimeSlots[0].end_time) ||
      (notAvailPopTimeSlots[0].start_time && notAvailPopTimeSlots[0].end_time)
    ) {
      setAvailPopTimeSlots(
        availPopTimeSlots[0].start_time
          ? [
              {
                start_time: availPopTimeSlots[0].start_time,
                end_time: availPopTimeSlots[0].end_time,
              },
            ]
          : ""
      );
      setNotAvailPopTimeSlots(
        notAvailPopTimeSlots[0].start_time
          ? [
              {
                start_time: notAvailPopTimeSlots[0].start_time,
                end_time: notAvailPopTimeSlots[0].end_time,
              },
            ]
          : ""
      );
    }
  };

  const handleAvailPopHours = (matrix, val) => {
    var changedAvailPop = [...availPopTimeSlots];
    var notAvailPop = [...notAvailPopTimeSlots];
    var placeholderDate = moment().format().split("T")[0];

    var dateToSet = new Date(moment(placeholderDate + " " + val).format());
    var dateToCompare = new Date(
      moment(
        placeholderDate + " " + changedAvailPop[matrix[0]][matrix[1] === "start_time" ? "end_time" : "start_time"]
      ).format()
    );

    var skipDateCheck =
      !changedAvailPop[matrix[0]]["start_time"] ||
      !changedAvailPop[matrix[0]]["end_time"];

    var oldestDate = notAvailPop[matrix[0]].start_time;
    var latestDate = notAvailPop[matrix[0]].end_time;

    var valToCompare = moment(val, "HH:mm: A").format();
    if (
      moment(valToCompare).isBetween(
        moment(oldestDate, "HH:mm: A").subtract(1, "seconds").format(),
        moment(latestDate, "HH:mm: A").add(1, "seconds").format()
      )
    ) {
      setAvailTimesError(true);
      changedAvailPop[matrix[0]][matrix[1]] = "";
      setAvailPopTimeSlots(changedAvailPop);
      setErrorPopUp("Time frame is already used.");
      return;
    }

    if (!skipDateCheck) {
      if (matrix[1] === "start_time") {
        if (dateToSet >= dateToCompare) {
          setAvailPopTimesError(true);
          changedAvailPop[matrix[0]][matrix[1]] = "";
          setAvailPopTimeSlots(changedAvailPop);
          setErrorPopUp("Please insert a correct time interval.");
          return;
        }
      } else {
        if (dateToCompare >= dateToSet) {
          setAvailPopTimesError(true);
          changedAvailPop[matrix[0]][matrix[1]] = "";
          setAvailPopTimeSlots(changedAvailPop);
          setErrorPopUp("Please insert a correct time interval.");
          return;
        }
      }
    }

    changedAvailPop[matrix[0]][matrix[1]] = val;
    setAvailPopTimeSlots(changedAvailPop);
  };

  const handleNotAvailPopHours = (matrix, val) => {
    let notAvailablePop = [...notAvailPopTimeSlots];
    var changedAvailPop = [...availPopTimeSlots];
    notAvailablePop[matrix[0]][matrix[1]] = val;

    var oldestDate = changedAvailPop[matrix[0]].start_time;
    var latestDate = changedAvailPop[matrix[0]].end_time;

    var valToCompare = moment(val, "HH:mm: A").format();
    if (
      moment(valToCompare).isBetween(
        moment(oldestDate, "HH:mm: A").subtract(1, "seconds").format(),
        moment(latestDate, "HH:mm: A").add(1, "seconds").format()
      )
    ) {
      setAvailTimesError(true);
      notAvailablePop[matrix[0]][matrix[1]] = "";
      setNotAvailPopTimeSlots(notAvailablePop);
      setErrorPopUp("Time frame is already used.");
      return;
    }

    setNotAvailPopTimeSlots(notAvailablePop);
  };

  // eslint-disable-next-line
  const addNewTimePop = () => {
    var changedAvailPop = [...availPopTimeSlots];
    changedAvailPop.push({ start_time: "", end_time: "" });
    setAvailPopTimeSlots(changedAvailPop);
  };

  const removeTimeFromPop = (item) => {
    var changedAvailPop = [...availPopTimeSlots];
    changedAvailPop.splice(item, 1);
    setAvailPopTimeSlots(changedAvailPop);
  };

  const openDelOverrideDateTime = (item, num) => {
    setDelDateOverride(true);
    setRememberInx(item);
    setRememberInxDel(num);
  };

  const closeDelOverrideDateTime = () => {
    setDelDateOverride(false);
    setRememberInx();
  };

  const confirmDelOverrideDateTime = () => {
    var timeSlots = [...availPopTimeSlotsSel];
    var changedAvailSel = timeSlots[rememberInx]?.times_data;

    let inx = changedAvailSel.findIndex((item) =>
      item.hasOwnProperty(rememberInxDel)
    );

    if (inx !== -1) {
      changedAvailSel.splice(inx, 1);
    }

    if (changedAvailSel.length === 0) {
      timeSlots.splice(rememberInx, 1);
    }

    setDelDateOverride(false);
    setAvailPopTimeSlotsSel(timeSlots);
  };

  const saveAvailTimesData = () => {
    var timeSlotCheck = function () {
      var isAllFilled = true;

      for (var day of availData) {
        if (day.available) {
          for (var slot of day.times) {
            if (!slot.start_time || !slot.end_time) {
              isAllFilled = false;
            }
          }
        }
      }
      return isAllFilled;
    };

    if (!timeSlotCheck()) {
      setAvailTimesError(true);
      setErrorPopUp("Please complete all required fields highlighted in red, then try saving again.");
      return;
    } else {
      setAvailTimesError(false);
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/save-availability-data", {
          available_times: availData,
          available_periods: availPopTimeSlotsSel,
          user_time_zone: initialTimeZone,
        })
        .then((res) => {
          if (res.data.responseData === "success") {
            setSuccPopUp("All changes have been saved.");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleOverideTimeFormat = (formatType) => {
    setAvailPopTimesError(false);
    setErrorRange(false);
    setOverideTimeFormat(formatType);
  };

  return (
    <div style={{flex: 1, height: '100%'}}>
      

      {isLoaded ? (
        <>
      <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
      <div
        style={{margin: 0}}
          className={"my_profile_option my_profile_opt_selected"}
        >
          Availability
        </div>
        {
          (!availHidden && isLoaded) && 
        <div
          style={{margin: 0}}
                className="save_btn_add_member avail_save_button"
                onClick={() => saveAvailTimesData()}
              >
                Save All Changes
              </div>
        }
      </div>
      {errorPopUp && (
        <div className="prog_err_hold my_prof_err_popup">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text">{errorPopUp}</div>
        </div>
      )}
      {succPopUp && (
        <div className="prog_err_hold prog_pop_pat_correct">
          <div className="prog_pop_icon_correct prog_err_icon"></div>
          <div className="prog_err_text prog_pop_text_correct">{succPopUp}</div>
        </div>
      )}

      {availToolHeight > 0 && availToolLeft > 0 && (
        <>
          <div
            className="dash_tooltip dash_tooltip_isolated"
            style={{
              position: "fixed",
              top: availToolHeight + "px",
              left: availToolLeft + "px",
              display: setAvailToolHeight ? "block" : "none",
            }}
          >
            <div className="dash_tooltip_text">
              {copyOrNew + " " + hoveredDay}
            </div>
            <div className="dash_arrow"></div>
          </div>
        </>
      )}
          {!availHidden ? (
            <div style={{padding: '0rem 1rem', margin: '0px auto', maxWidth: '1000px', marginBottom: '2rem' }}>
              {/* <div
                className="save_btn_add_member avail_save_button"
                onClick={() => saveAvailTimesData()}
              >
                Save All Changes
              </div> */}
              <div className="availability_row_container">
              <div className="avail_hours_side" style={{flex: 1.5, width: '100%'}}>
                <div className="availability_title">
                  Set up your weekly hours
                </div>
                {/* <div className="pt_reg_fields avail_fields_short">
                      <div className="avail_inp_hold">
                        <div className="pt_reg_inp_title">First Name</div>
                        <input
                          className="pt_reg_input_field avail_fields_short"
                          value={availData.first_name ? availData.first_name : ""}
                          placeholder="Enter your first name"
                        />
                      </div>
                      <div className="avail_inp_hold">
                        <div className="pt_reg_inp_title">Last Name</div>
                        <input
                          className="pt_reg_input_field avail_fields_short"
                          value={availData.last_name ? availData.last_name : ""}
                          placeholder="Enter your last name"
                        />
                      </div>
                    </div>
                    <div className="pt_reg_fields">
                      <div className="pt_reg_inp_title">Email</div>
                      <input
                        className="pt_reg_input_field"
                        value={availData.email ? availData.email : ""}
                        placeholder="Enter your email"
                      />
                    </div> */}
                <div className="avail_select_hold" style={{marginTop: '0px'}}>
                  <Select
                    initVal={initialTimeZone}
                    selectOptions={timeZoneSelectOpts}
                    selectCallback={handleUserTimeZone}
                    callBackValue={setInitialTimeZone}
                  />
                </div>
                {availData.map((item, i) => (
                  <div key={i} className="avail_time_container" style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
                    <div className="avail_days_center">
                      <div className="avail_checkbox_fill">
                        <div
                          className={
                            "register_check " +
                            (item.available ? "register_checked" : "")
                          }
                          onClick={() => handleAvailable(i)}
                        ></div>
                      </div>
                      <div className="avail_day_text">{item.day_name}</div>
                    </div>
                    {item.available ? (
                      <>
                        <div className="avail_timeslots_contain" style={{flex: 1}}>
                          {item.times.map((time, t) => (
                            <div key={t} className="avail_timeslot" style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                              <div className="avail_day_time_inp">
                                <AvailabilitySelect
                                  initVal={time.start_time}
                                  selectOptions={availHours}
                                  selectCallback={handleHours}
                                  callBackValue={[i, t, "start_time"]}
                                  selectError={
                                    availTimesError && !time.start_time
                                  }
                                />
                              </div>
                              <div className="avail_time_between_line ">
                                -
                              </div>
                              <div className="avail_day_time_inp">
                                <AvailabilitySelect
                                  initVal={time.end_time}
                                  selectOptions={availHours}
                                  selectCallback={handleHours}
                                  callBackValue={[i, t, "end_time"]}
                                  selectError={
                                    availTimesError && !time.end_time
                                  }
                                />
                              </div>
                              {/* {t > 0 && ( */}
                                <div
                                  style={{
                                    visibility: t > 0 ? "visible" : "hidden"
                                  }}
                                  className="avail_delete_bucket"
                                  onClick={() => deleteTime(i, t)}
                                ></div>
                              {/* )} */}
                            </div>
                          ))}
                        </div>

                        <div className="avail_add_copy_container" style={{display: 'flex', alignItems: 'center', position: 'relative'}}>
                          
                          <BootstrapTooltip title={`New interval for ${item?.day_name}`} placement="top">
                          <div
                            className="avail_icon avail_add_icon"
                            // onMouseOver={(e) =>
                            //   handleAvailTool(item, e, "New interval for")
                            // }
                            // onMouseLeave={() => handleAvailTool("close")}
                            onClick={() => addNewTime(i)}
                          ></div>
                          </BootstrapTooltip>
                          <BootstrapTooltip title={`Copy times for ${item?.day_name}`} placement="top">
                          <div
                            className={"avail_icon avail_copy_icon" + (openMulti === i ? " avail_icon_selected" : "")}
                            // onMouseOver={(e) => handleAvailTool(item, e, "Copy times for")}
                            // onMouseLeave={() => handleAvailTool("close")}
                            onClick={() =>
                              openCloseMulti(i, false, item.day_name)
                            }
                          ></div>
                          </BootstrapTooltip>
                        </div>
                        {openMulti === i && (
                          <MultiSelect
                            initVal={[]}
                            selectOptions={copyDayArr}
                            selectCallback={handleDaysToCopyTo}
                            callBackValue={i.toString()}
                            inAvailability={true}
                            openCloseMulti={openCloseMulti}
                          />
                        )}
                      </>
                    ) : (
                      <div className="avail_grey_text">Unavailable</div>
                    )}
                  </div>
                ))}
              </div>
              <div style={{width: '2px', background: '#e9eef6'}}></div>
              <div className="avail_override_side" style={{flex: 1, width: '100%'}}>
                <div className="availability_title">Add date overrides</div>
                <div
                  className="avail_add_override"
                  style={{height: '22px', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                  onClick={() => openCloseDateOverride()}
                >
                  Add a Date Override
                </div>
                {availPopTimeSlotsSel &&
                  availPopTimeSlotsSel.map((item, i) => (
                    <Fragment key={i}>
                      <div key={i} className="avail_override_timestamp" style={{ width: "100%" }}>
                        From {item.times_date[0]} to {item.times_date[1]}
                      </div>
                      <div className="avail_time_container avail_override_container">
                        {item.times_data && (
                          <div className="avail_override_times">
                            {item.times_data.map((slot, s) => (
                              <Fragment key={s}>
                                <div style={{ marginBottom: "10px" }}>
                                  {slot.allow_hours &&
                                    slot.allow_hours.start_time !==
                                      undefined && (
                                      <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div className="avail_day_time_inp availability_label">
                                          Available:
                                        </div>
                                        <div className="override_time_choose" style={{display: 'flex', alignItems: 'center'}}>
                                          <div
                                            key={s}
                                            className="avail_day_time_inp"
                                          >
                                            <Select
                                              initVal={
                                                slot.allow_hours.start_time
                                              }
                                              selectOptions={[]}
                                            />
                                          </div>
                                          <div className="avail_time_between_line line_override">
                                            -
                                          </div>
                                          <div className="avail_day_time_inp">
                                            <Select
                                              initVal={
                                                slot.allow_hours.end_time
                                              }
                                              selectOptions={[]}
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className="avail_delete_bucket avail_override_bucket"
                                          onClick={() =>
                                            openDelOverrideDateTime(
                                              i,
                                              "allow_hours"
                                            )
                                          }
                                        ></div>
                                      </div>
                                    )}
                                </div>
                                <div style={{ marginBottom: "10px" }}>
                                  {slot.block_hours &&
                                    slot.block_hours.start_time !==
                                      undefined && (
                                      <>
                                        <div className="avail_day_time_inp availability_label">
                                          Not Available:
                                        </div>
                                        <div className="override_time_choose">
                                          <div
                                            key={s}
                                            className="avail_day_time_inp"
                                          >
                                            <Select
                                              initVal={
                                                slot.block_hours.start_time
                                              }
                                              selectOptions={[]}
                                            />
                                          </div>
                                          <div className="avail_time_between_line line_override">
                                            -
                                          </div>
                                          <div className="avail_day_time_inp">
                                            <Select
                                              initVal={
                                                slot.block_hours.end_time
                                              }
                                              selectOptions={[]}
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className="avail_delete_bucket avail_override_bucket"
                                          onClick={() =>
                                            openDelOverrideDateTime(
                                              i,
                                              "block_hours"
                                            )
                                          }
                                        ></div>
                                      </>
                                    )}
                                </div>
                              </Fragment>
                            ))}
                          </div>
                        )}
                        {/* <div
                          className="avail_delete_bucket avail_override_bucket"
                          onClick={() => openDelOverrideDateTime(i)}
                        ></div> */}
                      </div>
                    </Fragment>
                  ))}
                {delDateOverride && (
                  <div
                    className="dlt_wrapper del_override_wrapper"
                    style={{
                      position: "fixed",
                    }}
                  >
                    <div className="dbl_place_on_page">
                      <div className="dlt_surround ">
                        <div className="dlt_title">Delete date override</div>
                        <div className="dlt_description">
                          <p>Are you sure want to delete?</p>
                        </div>
                        <div className="dlt_exit_btm">
                          <div
                            className="dlt_exit_btn dlt_eb_first"
                            onClick={() => closeDelOverrideDateTime()}
                          >
                            Cancel
                          </div>
                          <div
                            className="dlt_exit_btn dlt_eb_scnd"
                            onClick={() => confirmDelOverrideDateTime()}
                          >
                            Yes
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              </div>
              {openDateOverride && (
                <div className="dlt_wrapper">
                  <div className="dash_task_info_pop avail_info_pop">
                    <div className="avail_pop_title">
                      Select the date(s) to assign specific hours
                    </div>
                    <div className="ab_csh_title csh_title_top avail_pop_subtitle">
                      Select a date
                    </div>
                    <div className="ab_cali_hold">
                      <Calendar
                        onActiveStartDateChange={onActiveStartDateChange}
                        onClickDay={onClickDay}
                        onChange={updateDate}
                        selectRange={true}
                        calendarType={"ISO 8601"}
                        view={"month"}
                        minDate={new Date()}
                      />
                    </div>
                    <div className="avail_pop_timeslots">
                      {availPopDate == null ? (
                        <div className="avail_pop_no_slots">
                          Select the date(s) above to assign specific hours
                        </div>
                      ) : (
                        <>
                          <div className="programs_dash_top_hold">
                            <div className="programs_dash_top_options">
                              <div className="programs_dash_contain_opts">
                                <div
                                  className={
                                    "programs_dash_option avalabilityTabs" +
                                    (overideTimeFormat === "Available"
                                      ? " p_d_option_selected"
                                      : "")
                                  }
                                  onClick={() =>
                                    handleOverideTimeFormat("Available")
                                  }
                                >
                                  Available
                                </div>
                              </div>
                              <div className="programs_dash_contain_opts">
                                <div
                                  className={
                                    "programs_dash_option avalabilityTabs" +
                                    (overideTimeFormat === "NotAvailable"
                                      ? " p_d_option_selected"
                                      : "")
                                  }
                                  onClick={() =>
                                    handleOverideTimeFormat("NotAvailable")
                                  }
                                >
                                  Not Available
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={
                              "p_d_selected_slide availabilityMarkFirst" +
                              (overideTimeFormat === "NotAvailable"
                                ? " slide_opt_2 availabilityMark"
                                : "")
                            }
                          ></div>

                          {overideTimeFormat === "Available" && (
                            <>
                              <div className="ab_csh_title csh_title_top avail_pop_subtitle">
                                What time are you available?
                              </div>
                              <div className="avail_pop_times_contain">
                                {availPopTimeSlots.map((time, t) => (
                                  <div key={t} className="avail_time_container">
                                    <div className="avail_timeslot">
                                      <div className="avail_day_time_inp">
                                        <Select
                                          initVal={time.start_time}
                                          selectOptions={
                                            availPopDate[0] === moment(new Date()).format("l") &&
                                            availPopDate[1] === moment(new Date()).format("l")
                                              ? availPopHours
                                              : availHours
                                          }
                                          selectCallback={handleAvailPopHours}
                                          callBackValue={[t, "start_time"]}
                                          selectError={availPopTimesError}
                                        />
                                      </div>
                                      <div className="avail_time_between_line">
                                        -
                                      </div>
                                      <div
                                        className={
                                          "avail_day_time_inp " +
                                          (errorRange ? "errorTimeAvail" : "")
                                        }
                                      >
                                        <Select
                                          initVal={time.end_time}
                                          selectOptions={
                                            availPopDate[0] === moment(new Date()).format("l") &&
                                            availPopDate[1] === moment(new Date()).format("l")
                                              ? availPopHours
                                              : availHours
                                          }
                                          selectCallback={handleAvailPopHours}
                                          callBackValue={[t, "end_time"]}
                                          selectError={availPopTimesError}
                                        />
                                      </div>
                                    </div>
                                    <div className="avail_day_right">
                                      {/* <div className="avail_icon avail_add_icon" onClick={() => addNewTimePop()}></div> */}
                                      {t > 0 && (
                                        <div
                                          className="avail_icon avail_remove_icon"
                                          onClick={() => removeTimeFromPop(t)}
                                        ></div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                          {overideTimeFormat === "NotAvailable" && (
                            <>
                              <div className="ab_csh_title csh_title_top avail_pop_subtitle">
                                What time you are not available?
                              </div>
                              <div className="avail_pop_times_contain">
                                {availPopTimeSlots.map((time, t) => (
                                  <div key={t} className="avail_time_container">
                                    <div className="avail_timeslot">
                                      <div className="avail_day_time_inp">
                                        <Select
                                          initVal={
                                            notAvailPopTimeSlots
                                              ? notAvailPopTimeSlots[0]
                                                  .start_time
                                              : ""
                                          }
                                          selectOptions={
                                            availPopDate[0] === moment(new Date()).format("l") &&
                                            availPopDate[1] === moment(new Date()).format("l")
                                              ? availPopHours
                                              : availHours
                                          }
                                          selectCallback={
                                            handleNotAvailPopHours
                                          }
                                          callBackValue={[t, "start_time"]}
                                          selectError={availPopTimesError}
                                        />
                                      </div>
                                      <div className="avail_time_between_line">
                                        -
                                      </div>
                                      <div
                                        className={
                                          "avail_day_time_inp " +
                                          (errorRange ? "errorTimeAvail" : "")
                                        }
                                      >
                                        <Select
                                          initVal={
                                            notAvailPopTimeSlots
                                              ? notAvailPopTimeSlots[0].end_time
                                              : ""
                                          }
                                          selectOptions={
                                            availPopDate[0] === moment(new Date()).format("l") &&
                                            availPopDate[1] === moment(new Date()).format("l")
                                              ? availPopHours
                                              : availHours
                                          }
                                          selectCallback={
                                            handleNotAvailPopHours
                                          }
                                          callBackValue={[t, "end_time"]}
                                          selectError={availPopTimesError}
                                        />
                                      </div>
                                    </div>
                                    <div className="avail_day_right">
                                      {/* <div className="avail_icon avail_add_icon" onClick={() => addNewTimePop()}></div> */}
                                      {t > 0 && (
                                        <div
                                          className="avail_icon avail_remove_icon"
                                          onClick={() => removeTimeFromPop(t)}
                                        ></div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                    <div className="avail_pop_buttons_hold">
                      <div
                        className="avail_pop_button_canc"
                        onClick={() => openCloseDateOverride()}
                      >
                        Cancel
                      </div>
                      <div
                        className={
                          availPopDate?.length > 1
                            ? "avail_pop_button_save"
                            : "avail_pop_button_save_disabled"
                        }
                        onClick={() => openCloseDateOverride(true)}
                      >
                        Apply
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div style={{margin: "15px 10px"}}>{availHidden}</div>
          )}
        </>
      )
        :
      (
        <div className="programs_table_no_content loading_screen_container">
            <div className="no_content_notice_contain">
                <div className="p_load"></div>
            </div>
        </div>
      )}
    </div>
  );
};

export default Availability;
